import { useRef, useEffect } from 'react';

function useIsMountedRef() {
  var isMounted = useRef(true);
  useEffect(function () {
    return function () {
      isMounted.current = false;
    };
  }, []);
  return isMounted;
}

export { useIsMountedRef };
